/**
 * Load EditorJs for user-social-post-new
 */
import $ from 'jquery';
import EditorJS from '@editorjs/editorjs';
import axios from 'axios';

const editorConfig = {
  minHeight: 0,
  tools: {
    paragraph: {
      // inlineToolbar: ['link'],
      inlineToolbar: [],
    },
  },
  /**
   * Internationalzation config
   */
  i18n: {
    /**
     * @type {I18nDictionary}
     */
    messages: {
      /**
       * Section for translation Tool Names: both block and inline tools
       */
      toolNames: {
        'Link': 'Länk',
      },
      /**
       * Section for passing translations to the external tools classes
       */
      tools: {
        'link': {
          'Add a link': 'Ange länkadress',
        },
      },
    },
  },
};

export default class EditorJs {
  init(formSelector) {
    const form = $(formSelector);
    const holderId = `${formSelector}-editorjs`;
    const holder = holderId.substring(1);
    const editorElm = form.find(holderId);

    const confirmMsg = form.data('confirm');

    const loader = $(`${formSelector}-indicator`);
    const target = $(`${formSelector}-target`);

    if (!form.length || !editorElm.length) {
      return;
    }

    const placeholder = editorElm.data('placeholder');

    const editor = new EditorJS({
      ...editorConfig,
      holder,
      placeholder: placeholder || 'Skriv ditt inlägg…',
    });

    let heightChanged = false;
    const editorElement = document.getElementById(holder);
    editorElement.addEventListener('focusin', () => {
      if (heightChanged) {
        return;
      }
      const blockHolder = editorElm.find('.codex-editor__redactor');
      blockHolder.css('paddingBottom', blockHolder.height() * 2);
      heightChanged = true;

      form.find('.editor-js-image-picker').removeClass('d-none');
      form.find('.editor-js-image-picker').find('.btn').one('click', () => {
        form.find('.custom-file').removeClass('d-none');
        form.find('.editor-js-image-picker').remove();
      });
    });

    async function getEditorContent() {
      const data = await editor.save();
      const json = JSON.stringify(data)
      return json;
    }

    form.on('submit', async event => {
      event.preventDefault();

      if (confirm(confirmMsg)) {
        /**
         * Fix for Safari Webkit – empty file inputs kill the browser
         *
         * https://stackoverflow.com/a/49827426/586823
         */
        const fileInputs = $('input[type="file"]:not([disabled])', form)
        fileInputs.each((i, input) => {
          if (input.files.length > 0) {
            return;
          }
          $(input).prop('disabled', true);
        });

        let formData = new FormData(form[0]);

        // Add input text to submit
        const data = await getEditorContent();
        formData.append('data', data);

        // Add post fields
        form.find('input[type="hidden"]').each((idx, elm) => {
          const input = $(elm);
          formData.append(input.attr('name'), input.val());
        });

        loader.css('display', 'inline');

        // TODO replace axios with htmx.ajax

        axios
          .post(window?.sage?.ajaxurl, formData)
          .then(response => {
            target.html(response.data);
            htmx.process(document.body)
            editor.blocks.clear();
            $('#output_image').addClass('d-none');

            // Social post
            const modal = $('#user-social-post-new-target .modal');
            if (modal.length) {
              // Init acf fields inside modal
              acf.do_action('append', modal);
            }
          })
          .finally(() => {
            loader.css('display', 'none');
          });
      }
    });
  }
}
